import { createPersistedQueryLink } from "@apollo/client/link/persisted-queries";
import { Sha256 } from "@aws-crypto/sha256-browser";
export async function sha256(...args) {
    const hash = new Sha256();
    // We trim the query string here as well as in the http-link to ensure that the hash is consistent across different environments.
    hash.update(args.map((arg) => (typeof arg === "string" ? arg.trim() : arg)).join(""));
    return Array.from(await hash.digest())
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
}
export const persistedQueriesLink = () => {
    return createPersistedQueryLink({
        sha256,
        useGETForHashedQueries: true,
    });
};
//# sourceMappingURL=persisted-queries-link.js.map